export default class CartService {
  #apiUrl = "https://op-prime-55aad0906ec2.herokuapp.com/api/v1/fictional-chainsaw";
  constructor() {}

  /**
   * Fetches the current cart from Shopify's AJAX API.
   * @returns {Promise<Object|null>}
   */
  async getCart() {
    try {
      const response = await fetch("/cart.js");
      const data = await response.json();
      return data;
    } catch (error) {
      throw new Error("Error fetching cart data: " + error.message);
    }
  }

  /**
   * Uupdate the quantity of a variant in the cart
   * @returns {Promise<Object|null>}
   */
  async updateCart(variantId, quantity) {
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          updates: {
            [variantId]: quantity
          }
        })
      });
      return await response.json();
    } catch (error) {
      throw new Error("Error updating cart: " + error.message);
    }
  }

  /**
   * Sends cart data to a custom backend API (fictional chainsaw) to validate the discount code.
   * @param {string} discountCode discount code to validate
   * @param {Object} cartData body of actual cart
   * @returns {Promise<Object|null>}
   */
  async getDiscountCodeInformation(discountCode, cartData) {
    try {
      const response = await fetch(`${this.#apiUrl}/discounts/code/${discountCode}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(cartData)
      });
      const data = await response.json();
      return data;
    } catch (error) {
      throw new Error("Error validating discount code in api: " + error.message);
    }
  }

  /**
   * Validates a discount code by retrieving the current cart data and sending it to the backend API.
   *
   * This method first fetches the current cart contents, then formats the data and sends it
   * to a custom discount validation endpoint to retrieve discount or gift-related information.
   *
   * @async
   * @param {string} code - The discount code to validate.
   * @returns {Promise<Object|null>} - Returns the discount validation result from the backend, or null if validation fails or the cart is unavailable.
   */
  async validateDiscount(code) {
    try {
      if (!code) return null;
      const cart = await this.getCart();
      if (!cart) return null;
      const cartData = {
        totalCart: cart.total_price,
        items: cart.items.map(item => ({
          id: item.product_id,
          title: item.product_title,
          quantity: item.quantity,
          variantId: item.variant_id,
          price: item.price
        }))
      };
      return await this.getDiscountCodeInformation(code, cartData);
    } catch (error) {
      throw new Error("Error validating discount code: " + error.message);
    }
  }
}